import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { firstValueFrom, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LOCAL_AUTH_FAILURE } from '../interceptors/local-auth-failure';

export interface NavigationAvailability { qr: boolean | null; counsel: boolean | null; reservation: boolean | null; }
const record = (value: unknown): value is Record<string, unknown> => !!value && typeof value === 'object' && !Array.isArray(value);
const flag = (value: unknown): boolean | null => value === true || value === 1 || value === '1' ? true :
  value === false || value === 0 || value === '0' ? false : null;

/** Optional navigation metadata must not redirect or replay the active page's operation. */
@Injectable({ providedIn: 'root' })
export class NavigationAvailabilityService {
  private readonly http = inject(HttpClient);
  private async read(path: string, select: (result: unknown) => unknown = result => result): Promise<boolean | null> {
    try {
      const response = await firstValueFrom(this.http.get<unknown>(`${environment.apiBaseUrl}${path}`, {
        context: new HttpContext().set(LOCAL_AUTH_FAILURE, true),
      }).pipe(timeout(30000)));
      return record(response) && response['success'] === true ? flag(select(response['result'])) : null;
    } catch { return null; }
  }
  async load(): Promise<NavigationAvailability> {
    const [qr, counsel, reservation] = await Promise.all([
      this.read('/inout/qr/is_configured'),
      this.read('/member/self', result => record(result) && record(result['studio']) ? result['studio']['isCounselable'] : undefined),
      this.read('/reservation/flag/mypage'),
    ]);
    return { qr, counsel, reservation };
  }
}
